import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AppState } from '@citypantry/state';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthSelectors } from '../state/auth.select';

@Injectable({
  providedIn: 'root',
})
export class IsLoggedInGuard implements CanActivate {
  constructor(
    private store: Store<AppState>,
    private router: Router,
  ) {}

  public canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return this.store.select(AuthSelectors.isLoggedInUser).pipe(
      map((isLoggedInUser) => {
        if (isLoggedInUser) {
          return true;
        }

        return this.router.parseUrl(`/login?forward=${encodeURIComponent(state.url)}`);
      })
    );
  }
}
